/** @jsxImportSource @emotion/react */
import { useMemo } from "react";
import { useTheme, Container, Link, Stack, Text } from "basis";
import { CreditCard } from "../CreditCard/CreditCard";
import { DownloadButton } from "../DownloadButton/DownloadButton";
import { BpayDetails } from "./BpayDetails";
import { BpayReceiptPdf } from "./BpayReceiptPdf";

function BpaySuccess({ state }) {
  const theme = useTheme();
  const {
    fromAccount,
    biller,
    referenceNumber,
    amount,
    paymentDate,
    receiptNumber,
  } = state;
  const { cardName, cardEndsWith } = fromAccount.data;
  // It's important to memoize the pdf since DownloadButton uses React.memo
  const detailsPdf = useMemo(
    () => (
      <BpayReceiptPdf
        cardName={cardName}
        cardEndsWith={cardEndsWith}
        biller={biller}
        referenceNumber={referenceNumber}
        amount={amount}
        paymentDate={paymentDate}
        receiptNumber={receiptNumber}
      />
    ),
    [
      cardEndsWith,
      cardName,
      biller,
      referenceNumber,
      amount,
      paymentDate,
      receiptNumber,
    ],
  );

  return (
    <Stack gap="8">
      <Container bg="grey.t05" padding="4">
        <CreditCard cardName={cardName} cardEndsWith={cardEndsWith} />
      </Container>
      <BpayDetails
        biller={biller}
        referenceNumber={referenceNumber}
        amount={amount}
        paymentDate={paymentDate}
        receiptNumber={receiptNumber}
      />
      <div>
        <div
          css={{
            padding: `${theme.space[3]} 0`,
            borderBottom: `${theme.borderWidths[0]} solid ${theme.colors.black}`,
          }}
        >
          <Text>Please download the following documents for your records.</Text>
        </div>
        <div
          css={{
            borderBottom: `${theme.borderWidths[0]} solid ${theme.colors.grey.t10}`,
          }}
        >
          <DownloadButton pdf={detailsPdf}>BPay payment receipt</DownloadButton>
        </div>
      </div>
      <Container>
        <Link appearance="primary-button" href="/" newTab={false}>
          Go to overview
        </Link>
      </Container>
    </Stack>
  );
}

export { BpaySuccess };
